import { convertDxFilterGroupToFiql } from './convert-dx-filter-group-to-fiql';
import { convertDxFilterOperationToFiql } from './convert-dx-filter-operation-to-fiql';

export const DEFAULT_CONVERT_OPTIONS = {
  operationToConstraint: convertDxFilterOperationToFiql,
  groupToExpression: convertDxFilterGroupToFiql,
};
